var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/urls.j2"] = require( "macros/urls.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/contentful/product-tray/headline.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/urls.j2", false, "core/templates/contentful/product-tray/headline.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("contentfulUrl")) {
var t_4 = t_1.contentfulUrl;
} else {
cb(new Error("cannot import 'contentfulUrl'")); return;
}
context.setVariable("contentfulUrl", t_4);
output += "<div class=\"o-row\">\n\n    <div class=\"o-column o-extra-small--12\">\n\n        <div class=\"c-product-tray__header u-clearfix\">\n\n            <div class=\"o-row\">\n\n                <div class=\"o-column o-extra-small--12 c-product-tray__heading-outer\">\n\n                    <h2 class=\"c-product-tray__h2\" data-qa-product-tray-headline>\n\n                        ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "entry")),"fields")),"headline"), env.opts.autoescape);
output += "\n\n                    </h2>\n\n                    ";
var t_5;
t_5 = (lineno = 18, colno = 43, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["entry.fields.seeMoreLink.fields",{}]));
frame.set("seeMoreLink", t_5, true);
if(frame.topLevel) {
context.setVariable("seeMoreLink", t_5);
}
if(frame.topLevel) {
context.addExport("seeMoreLink", t_5);
}
output += "\n                    ";
if(runtime.contextOrFrameLookup(context, frame, "seeMoreLink")) {
output += "\n                        <span class=\"c-product-tray__more-link-outer\">\n\n                            <a\n                                ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "seeMoreLink")),"openInNewWindow")) {
output += "target=\"_blank\" rel=\"noopener noreferrer\"";
;
}
output += "href=\"";
output += runtime.suppressValue((lineno = 24, colno = 52, runtime.callWrap(t_4, "contentfulUrl", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "seeMoreLink")),"linkPath")])), env.opts.autoescape);
output += "\"\n                                class=\"c-product-tray__more-link\"\n                                data-qa-see-more-link>\n\n                                ";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "seeMoreLink")),"linkTitle"), env.opts.autoescape);
output += "\n\n                            </a>\n\n                        </span>\n\n                    ";
;
}
output += "\n\n                </div>\n\n            </div>\n\n        </div>\n\n    </div>\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/contentful/product-tray/headline.j2"] , dependencies)